export function formatEventDate(iso) {
	if (!iso) return '';
	try {
		const d = new Date(iso + 'T00:00:00');
		return d.toLocaleDateString(undefined, { day: '2-digit', month: 'short', year: 'numeric' });
	} catch { return iso; }
}